(() => {
  const modulo = (value, divisor) =>
    ((value % divisor) + divisor) % divisor;

  function initializeInfiniteReviews(root = document) {
    root.querySelectorAll(".tc-carousel").forEach((carousel) => {
      const track = carousel.querySelector(".tc-track");

      if (!track || track.dataset.infiniteReviews === "true") {
        return;
      }

      const originalSlides = Array.from(track.children);

      if (originalSlides.length < 2) {
        return;
      }

      track.dataset.infiniteReviews = "true";

      const removeDuplicateIds = (element) => {
        element.removeAttribute("id");

        element.querySelectorAll("[id]").forEach((child) => {
          child.removeAttribute("id");
        });
      };

      const createClone = (slide) => {
        const clone = slide.cloneNode(true);

        clone.dataset.reviewClone = "true";
        clone.setAttribute("aria-hidden", "true");

        removeDuplicateIds(clone);

        return clone;
      };

      /* Um conjunto antes dos originais */
      const beforeFragment = document.createDocumentFragment();

      originalSlides.forEach((slide) => {
        beforeFragment.appendChild(createClone(slide));
      });

      track.insertBefore(beforeFragment, track.firstChild);

      /* Um conjunto depois dos originais */
      const afterFragment = document.createDocumentFragment();

      originalSlides.forEach((slide) => {
        afterFragment.appendChild(createClone(slide));
      });

      track.appendChild(afterFragment);

      const slideCount = originalSlides.length;

      let cycleWidth = 0;
      let scrollTimer = null;
      let initializedPosition = false;

      const measureCycle = () => {
        const firstOriginal = track.children[slideCount];
        const firstFollowingClone = track.children[slideCount * 2];

        if (!firstOriginal || !firstFollowingClone) {
          return;
        }

        cycleWidth =
          firstFollowingClone.offsetLeft - firstOriginal.offsetLeft;

        if (!cycleWidth) {
          return;
        }

        if (!initializedPosition) {
          const previousBehavior = track.style.scrollBehavior;

          track.style.scrollBehavior = "auto";
          track.scrollLeft = cycleWidth;
          track.style.scrollBehavior = previousBehavior;

          initializedPosition = true;
        }
      };

      const normalizePosition = () => {
        if (!cycleWidth) {
          return;
        }

        const equivalentPosition =
          cycleWidth +
          modulo(track.scrollLeft - cycleWidth, cycleWidth);

        if (Math.abs(track.scrollLeft - equivalentPosition) < 2) {
          return;
        }

        const previousBehavior = track.style.scrollBehavior;

        track.style.scrollBehavior = "auto";
        track.scrollLeft = equivalentPosition;

        requestAnimationFrame(() => {
          track.style.scrollBehavior = previousBehavior;
        });
      };

      const getSlideStep = () => {
        const slide = track.children[slideCount];

        if (!slide) {
          return 300;
        }

        const trackStyles = window.getComputedStyle(track);
        const gap =
          parseFloat(trackStyles.columnGap) ||
          parseFloat(trackStyles.gap) ||
          0;

        return slide.getBoundingClientRect().width + gap;
      };

      const moveSlider = (direction) => {
        track.scrollBy({
          left: direction * getSlideStep(),
          behavior: "smooth",
        });
      };

      const previousButton = carousel.querySelector(
        ".tc-arrow--prev"
      );

      const nextButton = carousel.querySelector(
        ".tc-arrow--next"
      );

      const keepButtonEnabled = (button) => {
        if (!button) {
          return;
        }

        button.removeAttribute("disabled");
        button.setAttribute("aria-disabled", "false");

        const observer = new MutationObserver(() => {
          if (button.hasAttribute("disabled")) {
            button.removeAttribute("disabled");
          }

          if (button.getAttribute("aria-disabled") === "true") {
            button.setAttribute("aria-disabled", "false");
          }
        });

        observer.observe(button, {
          attributes: true,
          attributeFilter: ["disabled", "aria-disabled"],
        });
      };

      keepButtonEnabled(previousButton);
      keepButtonEnabled(nextButton);

      if (previousButton) {
        previousButton.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            moveSlider(-1);
          },
          true
        );
      }

      if (nextButton) {
        nextButton.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            moveSlider(1);
          },
          true
        );
      }

      /* Normaliza depois de um swipe ou scroll */
      track.addEventListener(
        "scroll",
        () => {
          window.clearTimeout(scrollTimer);

          scrollTimer = window.setTimeout(
            normalizePosition,
            130
          );
        },
        { passive: true }
      );

      if ("onscrollend" in track) {
        track.addEventListener(
          "scrollend",
          normalizePosition,
          { passive: true }
        );
      }

      /* Permite arrastar com rato no computador */
      let mouseDragging = false;
      let mouseStartX = 0;
      let initialScrollLeft = 0;

      track.addEventListener("pointerdown", (event) => {
        if (event.pointerType !== "mouse" || event.button !== 0) {
          return;
        }

        mouseDragging = true;
        mouseStartX = event.clientX;
        initialScrollLeft = track.scrollLeft;

        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener("pointermove", (event) => {
        if (!mouseDragging) {
          return;
        }

        event.preventDefault();

        const movement = event.clientX - mouseStartX;
        track.scrollLeft = initialScrollLeft - movement;
      });

      const stopMouseDrag = (event) => {
        if (!mouseDragging) {
          return;
        }

        mouseDragging = false;

        if (track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }

        normalizePosition();
      };

      track.addEventListener("pointerup", stopMouseDrag);
      track.addEventListener("pointercancel", stopMouseDrag);

      /* Recalcula quando imagens ou ecrã mudam de tamanho */
      track.querySelectorAll("img").forEach((image) => {
        if (!image.complete) {
          image.addEventListener(
            "load",
            () => {
              requestAnimationFrame(measureCycle);
            },
            { once: true }
          );
        }
      });

      if ("ResizeObserver" in window) {
        const resizeObserver = new ResizeObserver(() => {
          requestAnimationFrame(() => {
            measureCycle();
            normalizePosition();
          });
        });

        resizeObserver.observe(track);
      } else {
        window.addEventListener("resize", () => {
          requestAnimationFrame(() => {
            measureCycle();
            normalizePosition();
          });
        });
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(measureCycle);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializeInfiniteReviews();
    });
  } else {
    initializeInfiniteReviews();
  }

  /* Suporte ao editor visual do Shopify */
  document.addEventListener("shopify:section:load", (event) => {
    initializeInfiniteReviews(event.target);
  });
})();